export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14970.f3aee4ee.jpg";